import {isMobile} from 'react-device-detect'
import ReactGA from 'react-ga'
import { getCookie } from './cookie'

const logger = ({error, name, element}) => {
  const device = isMobile ? `MOV` : `WEB`
  const text = tags({device, error, name, element})

  ReactGA.pageview(text)
  // dynatrace
  // const dtrum = window.dtrum
  // dtrum && dtrum.identifyUser(text)
  //
  console.log(`logger`, text)
}

const tags = ({device, error, name, element}) => {
  const isTotem = Boolean(getCookie('is-totem'));
  const addTotemId = isTotem ? '_Totem' : '';

  const content = {
    OpenModalToken: `/MinhaClaroPF/${device}/fatura-facil/click/OpenModalToken${addTotemId}/success`,
    ErrorOpenModalToken: `/MinhaClaroPF/${device}/fatura-facil/error/ErrorOpenModalToken${addTotemId}/${error}/failure`,
    ErrorInvalidoToken: `/MinhaClaroPF/${device}/fatura-facil/error/ErrorInvalidoToken${addTotemId}/${error}/failure`,
    CloseModalToken: `/MinhaClaroPF/${device}/fatura-facil/click/CloseModalToken${addTotemId}/success`,
    ResendCodeToken: `/MinhaClaroPF/${device}/fatura-facil/click/ResendCodeToken${addTotemId}/success`,
    LoadPage: `/MinhaClaroPF/${device}/fatura-facil/loadPage${addTotemId}/success`,
    GetInvoices: `/MinhaClaroPF/${device}/fatura-facil/click/BotaoAcessarFaturas${addTotemId}/success`,
    ViewBarCode: `/MinhaClaroPF/${device}/fatura-facil/click/BotaoVisualizarCodigoDeBarras${addTotemId}/success`,
    CopyPixButton: `/MinhaClaroPF/${device}/fatura-facil/click/BotaoCopiarCodigoPix${addTotemId}/success`,
    CopyBarCodeButton: `/MinhaClaroPF/${device}/fatura-facil/click/BotaoCopiarCodigoDeBarras${addTotemId}/success`,
    CopyBarCodeButtonModal: `/MinhaClaroPF/${device}/fatura-facil/click/BotaoCopiarCodigoDeBarrasDetalhes${addTotemId}/success`,
    CopyBarCode: `/MinhaClaroPF/${device}/fatura-facil/click/ImagemCopiarCodigoDeBarras${addTotemId}/success`,
    HasInvoices: `/MinhaClaroPF/${device}/fatura-facil/info/ClienteComFaturasEmAberto${addTotemId}/success`,
    HasNoInvoices: `/MinhaClaroPF/${device}/fatura-facil/info/ClienteSemFaturasEmAberto${addTotemId}/success`,
    ErrorApiInvoices: `/MinhaClaroPF/${device}/fatura-facil/error/ErroAPIInvoices${addTotemId}/${error}/failure`,
    PoliticaDePrivacidade: `/MinhaClaroPF/${device}/fatura-facil/click/PoliticaDePrivacidade${addTotemId}/success`,
    PortalDePrivacidade: `/MinhaClaroPF/${device}/fatura-facil/click/PortalDePrivacidade${addTotemId}/success`,
    RedirectFaturaDetalhada: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarFaturaDetalhada${addTotemId}/success`,
    RedirectSegundaVia: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarSegundaVia${addTotemId}/success`,
    RedirectFormasPagamento: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarFormasPagamento${addTotemId}/success`,
    RedirectGooglePlay: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarGooglePlay${addTotemId}/success`,
    RedirectAppStore: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarAppStore${addTotemId}/success`,
    RedirectCaixa: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarCaixa${addTotemId}/success`,
    RedirectItau: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarItau${addTotemId}/success`,
    RedirectBradesco: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarBradesco${addTotemId}/success`,
    RedirectSantander: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarSantander${addTotemId}/success`,
    RedirectSafra: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarSafra${addTotemId}/success`,
    Incentivo: `/MinhaClaroPF/${device}/fatura-facil/click/redirect/minha-claro${addTotemId}/${error}`,
    RedirectBrasil: `/MinhaClaroPF/${device}/fatura-facil/click/RedirecionarBrasil${addTotemId}/success`,
    ChangeFatura: `/MinhaClaroPF/${device}/fatura-facil/click/ChangeFatura${addTotemId}/success`,
    PagarComCodigoDeBarras: `/MinhaClaroPF/${device}/fatura-facil/click/RedirectPageCodigoBarra${addTotemId}/success`,
    PagarComPIX: `/MinhaClaroPF/${device}/fatura-facil/click/RedirectPagePIX${addTotemId}/success`,
    TentarNovamente: `/MinhaClaroPF/${device}/fatura-facil/click/TentarNovamente${addTotemId}/success`,
    Botao: `/MinhaClaroPF/${device}/fatura-facil/click/BotaoModalError${addTotemId}/success`,
    RedirectClaroResidencialFaturaFacil: `/MinhaClaroPF/${device}/fatura-facil/click/RedirectClaroResidencialFaturaFacil${addTotemId}/success`,
    ConsultarOutroSemFatura: `/MinhaClaroPF/${device}/fatura-facil/click/ClienteSemFaturaEmAberto/ConsultarOutroNumero${addTotemId}/success`,
    InstallPWA: `/MinhaClaroPF/${device}/fatura-facil/click/InstallPWA${addTotemId}/success`,
    UnInstallPWA: `/MinhaClaroPF/${device}/fatura-facil/click/UnInstallPWA${addTotemId}/success`,
    ClosePWA: `/MinhaClaroPF/${device}/fatura-facil/click/ClosePWA${addTotemId}/success`,
    AbriuPWA: `/MinhaClaroPF/${device}/fatura-facil/click/AbriuPWA${addTotemId}/success`,
    Banners: `/MinhaClaroPF/${device}/fatura-facil/click/Banners${addTotemId}/${element}/success`,
    PagueSuaFatura: `/MinhaClaroPF/${device}/fatura-facil/click/PagueSuaFatura${addTotemId}/${element}/success`,
    FacilidadesMCM: `/MinhaClaroPF/${device}/fatura-facil/click/FacilidadesMCM${addTotemId}/${element}/success`,
    RedirectClaroEmpresas: `/MinhaClaroPF/${device}/fatura-facil/click/RedirectClaroNegocie${addTotemId}/success`,
    RedirectClaroNegocie: `/MinhaClaroPF/${device}/fatura-facil/click/RedirectClaroNegocie${addTotemId}/success`,
  }
  return content[name]
}

export {logger, tags}
